<template>
  <component :is="process"  @changeSaveButton="$emit('changeSaveButton', $event)" />
</template>

<script>
import basic from './default.vue';

export default {
  name: 'profile-info',
  components: {default: basic},
  props: ['process']
}
</script>